/* global __API_ROOT_URL__ */

import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';


let _$http;
let _upload;
let _utilityService;

class docDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _upload = Upload;
    _utilityService = utilityService;

    this.cache = {};
    console.log('app.services.docDataService created');
  }

  getChildItemList(serviceId, folderId) {
    return _$http({
      url: `${__API_ROOT_URL__}/doc/folder/${folderId}/childItems`,
      method: 'GET',
      params: {
        serviceId,
      }
    });
  }

  getItemList(serviceId, parentId, attachmentTypeId, attachmentEntityId) {
    return _$http({
      url: `${__API_ROOT_URL__}/doc/folder/byServiceAndParent`,
      method: 'GET',
      params: {
        serviceId,
        parentId,
        typeId: attachmentTypeId,
        entityId: attachmentEntityId,
      }
    });
  }

  // ///////////// Folders ///////////////////

  getFolderProperties(folderId) {
    return _$http({
      url: `${__API_ROOT_URL__}/doc/folder/${folderId}/properties/`,
      method: 'GET',
      params: {}
    });
  }

  getFolderVisiblities(folderId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/folderVisibility/byFolder`,
      method: 'GET',
      params: {
        folderId
      }
    });
  }

  saveFolder(customerId, serviceId, parentFolderId, folderId, folderName, assignments, applyToChildren) { // assignments
    return _$http(
      {
        url: `${__API_ROOT_URL__}/doc/folder`,
        method: 'POST',
        params: { echo: true },
        data: _utilityService.serializeData({
          // customerId: customerId,
          serviceId,
          folderId,
          parentFolderId,
          folderName,
          assignments,
          applyToChildren,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    );
  }

  deleteFolder(folderId) {
    return _$http({
      url: `${__API_ROOT_URL__}/doc/folder/${folderId}`,
      method: 'DELETE'
    });
  }

  folderExists(customerId, parentFolderId, folderId, folderName) {
    return _$http({
      url: `${__API_ROOT_URL__}/doc/folder/exists`,
      method: 'GET',
      params: {
        // customerId: customerId,
        parentFolderId,
        folderId,
        folderName
      }
    });
  }

  // ///////////// Documents ///////////////////

  getDocumentVisiblities(documentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/documentVisibility/byDocument`,
      method: 'GET',
      params: {
        documentId
      }
    });
  }

  getDocumentAssociations(documentId, serviceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/associations`,
      method: 'GET',
      params: {
        documentId,
        serviceId
      }
    });
  }

  getDocumentAssociationsByFolder(folderId, serviceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/folder/associations`,
      method: 'GET',
      params: {
        folderId,
        serviceId
      }
    });
  }

  saveDocument(customerId, serviceId, folderId, file) {
    return _upload.upload({
      url: `${__API_ROOT_URL__}/media/document/upload`,
      data: {
        // customerId: customerId,
        serviceId,
        folderId,
        file,
        echo: true
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  saveDocuments(customerId, serviceId, folderId, files) {
    return _upload.upload({
      url: `${__API_ROOT_URL__}/media/document/upload`,
      data: {
        // customerId: customerId,
        serviceId,
        folderId,
        files,
        echo: true
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  saveDocumentProperties(serviceId, doc) {
    return _$http(
      {
        url: `${__API_ROOT_URL__}/media/document/${doc.documentId}/saveProperties`,
        method: 'PUT',
        params: {
          serviceId,
          assignments: doc.assignments,
          echo: true
        },
      }
    );
  }

  deleteDocument(documentId, customerId, serviceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document`,
      method: 'DELETE',
      params: {
        documentId,
        serviceId
      }
    });
  }

  documentExists(customerId, parentFolderId, documentId, fileName) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/exists`,
      method: 'GET',
      params: {
        // customerId: customerId,
        parentFolderId,
        documentId,
        fileName
      }
    });
  }

  documentsExist(customerId, parentFolderId, documentId, fileNames) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/exists`,
      method: 'GET',
      params: {
        // customerId: customerId,
        parentFolderId,
        documentId,
      },
      data: _utilityService.serializeData(fileNames)
    });
  }

  moveDocument(customerId, folderId, documentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/move`,
      method: 'PUT',
      params: {
        // customerId: customerId,
        folderId,
        documentId,
        echo: true,
      }
    });
  }

  // ///////////// Reports ///////////////////

  getCustomerReportInstances() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/Instance/attachable/byCustomer`,
      method: 'GET',
      params: {}
    });
  }

  getUserReportInstances() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/Instance/attachable/byUser`,
      method: 'GET',
      params: {}
    });
  }

  getArchivedReportInstances() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/attachable/archived`,
      method: 'GET',
      params: {}
    });
  }
}


docDataService.$inject = [
  '$http',
  'Upload',
  'utilityService'
];

export default angular.module('app.services.docDataService', [
  ngFileUpload,
  constants,
])
  .service('docDataService', docDataService)
  .name;
